var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalCreateGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_185_4213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 150,
    height: 150,
    rx: 38,
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 150,
    height: 150,
    rx: 38,
    stroke: "url(#paint0_linear_185_4213)",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.4395 40C61.1759 40 48.8023 52.4617 48.8023 67.8341C48.8023 69.1922 48.8991 70.5282 49.086 71.8353C49.4287 72.7522 49.8155 73.6473 50.2438 74.5178C54.2115 82.582 61.7412 88.5496 70.7502 90.3395C72.5886 90.7048 74.4907 90.8966 76.4397 90.8966C78.1064 90.8966 79.7388 90.7563 81.3263 90.4873C90.5251 88.9283 98.2732 83.0335 102.416 74.9539C102.933 73.9473 103.393 72.9067 103.793 71.8363C103.98 70.5289 104.077 69.1926 104.077 67.8341C104.077 52.4617 91.7032 40 76.4395 40Z",
    fill: "url(#paint1_linear_185_4213)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.544 82.0714C98.4304 88.8861 90.8392 93.7137 82.1125 95.1927C81.1967 95.3479 80.2688 95.4661 79.3304 95.5459C79.5956 96.0163 79.8877 96.526 80.2056 97.0804L85.8573 106.939C86.5691 108.181 87.2273 109.33 87.8549 110.136C88.4696 110.926 89.6238 112.142 91.4263 111.986C93.2516 111.829 94.1699 110.407 94.6255 109.512C95.0868 108.606 95.5097 107.36 95.9639 106.021L96.7878 103.594C97.2445 102.248 97.5194 101.452 97.788 100.899C97.9107 100.646 97.9967 100.522 98.0442 100.464C98.066 100.437 98.0818 100.423 98.0818 100.423L98.0858 100.42L98.0902 100.418L98.0995 100.413C98.0995 100.413 98.1194 100.406 98.1532 100.401C98.2268 100.388 98.3764 100.375 98.6549 100.395C99.2649 100.437 100.087 100.595 101.472 100.87L103.972 101.365C105.35 101.638 106.633 101.892 107.643 101.943C108.64 101.993 110.322 101.903 111.37 100.39C112.405 98.8953 111.937 97.2808 111.565 96.3497C111.185 95.3992 110.527 94.2509 109.815 93.0091L103.988 82.8448C103.835 82.5781 103.688 82.3204 103.544 82.0714Z",
    fill: "url(#paint2_linear_185_4213)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7153 95.4646C71.742 95.3576 70.7807 95.2091 69.8333 95.0209C61.2189 93.3093 53.7804 88.3209 48.8453 81.402C48.5653 81.8793 48.2704 82.394 47.9527 82.9483L42.1853 93.009C41.4731 94.2508 40.8146 95.3991 40.435 96.3497C40.0631 97.2808 39.5948 98.8953 40.6297 100.39C41.6778 101.903 43.3601 101.993 44.3571 101.943C45.3666 101.892 46.6498 101.638 48.0283 101.365L50.5275 100.87C51.9131 100.595 52.7351 100.437 53.345 100.395C53.6236 100.375 53.7732 100.388 53.8468 100.401C53.8806 100.406 53.9005 100.413 53.9005 100.413L53.9098 100.418L53.9182 100.423C53.9182 100.423 53.934 100.437 53.9558 100.464C54.0033 100.522 54.0893 100.646 54.212 100.899C54.4806 101.452 54.7555 102.248 55.2122 103.594L56.036 106.021C56.4903 107.36 56.9132 108.606 57.3745 109.512C57.8301 110.407 58.7484 111.829 60.5737 111.986C62.3762 112.142 63.5304 110.926 64.1451 110.136C64.7727 109.33 65.4309 108.181 66.1427 106.939L71.7942 97.0808C72.1306 96.494 72.4381 95.9575 72.7153 95.4646Z",
    fill: "url(#paint3_linear_185_4213)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_185_4213",
    x: -24,
    y: -24,
    width: 200,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_185_4213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_185_4213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_4213",
    x1: 76,
    y1: 1,
    x2: 76,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_185_4213",
    x1: 40,
    y1: 112,
    x2: 113.534,
    y2: 41.6025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_185_4213",
    x1: 40,
    y1: 112,
    x2: 113.534,
    y2: 41.6025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_185_4213",
    x1: 40,
    y1: 112,
    x2: 113.534,
    y2: 41.6025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DFE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalCreateGoals);
export default __webpack_public_path__ + "static/media/Goal-Create-Goals.6290d2912c914f85ba741b30b11985d7.svg";
export { ForwardRef as ReactComponent };